import React, { createContext, useCallback, useContext, useEffect, useState } from "react";

const dict = {
  en: {
    // Nav
    "nav.home": "Home",
    "nav.events": "Events",
    "nav.gallery": "Gallery",
    "nav.vip": "VIP Tables",
    "nav.tickets": "Drinks Tickets",
    "nav.contact": "Contact",
    "nav.reserve": "Reserve",
    "nav.reserveTable": "Reserve a Table",

    // Hero
    "hero.overline": "Playa de las Américas · Tenerife",
    "hero.tagline": "Where bottles pop, the music hits harder, and unforgettable memories are made.",
    "hero.subtag": "Reserve your table and experience SOHO69.",
    "hero.cta.reserve": "Reserve a Table",
    "hero.cta.inside": "Inside the club",
    "door.openTonight": "Open tonight · doors live",
    "door.openIn": "Doors open in",
    "door.closed": "Closed · back",
    "door.openNow": "Open now · come find us",
    "door.closedBack": "Closed · back at 11am",
    "ticker.drinks": "Premium Drinks",
    "ticker.sound": "The Hottest Sound",
    "ticker.vip": "VIP Experience",
    "ticker.shisha": "Premium Shisha",

    "packages.kicker": "Drinks Packages",
    "packages.title.1": "Pick your",
    "packages.title.2": "package",
    "packages.sub": "Every package includes free fizz on arrival & unlimited mixers.",
    "packages.featured": "Most Popular",
    "packages.reserve": "Reserve Now",
    "packages.build": "Build your own package",
    "packages.buildHint": "Browse the full VIP bottle menu",

    "week.kicker": "What's on",
    "week.title.1": "Soho69 Weekly",
    "week.title.2": "Line-Up",
    "week.mon.day": "Monday",
    "week.tue.day": "Tuesday",
    "week.wed.day": "Wednesday",
    "week.thu.day": "Thursday",
    "week.fri.day": "Friday",
    "week.sat.day": "Saturday",
    "week.sun.day": "Sunday",
    "week.mon.title": "Pink Mondays",
    "week.mon.genres": "Ladies Night · Cocktails · R&B · House · VIP Deals",
    "week.mon.sub": "Start your week in pink.",
    "week.tue.title": "Tequila Tuesdays",
    "week.tue.genres": "2-for-1 Cocktails · Hip-Hop · Dance · Commercial Hits",
    "week.tue.sub": "Shots, shishas & late nights.",
    "week.wed.title": "Ballers Club",
    "week.wed.genres": "VIP Tables · Bottle Shows · Hip-Hop · Afrobeats",
    "week.wed.sub": "Big spenders, big vibes.",
    "week.thu.title": "Sunset Sessions",
    "week.thu.genres": "House · Ibiza Classics · Happy Hour · Terrace Vibes",
    "week.thu.sub": "Golden hour turns into after hours.",
    "week.fri.title": "Friday Takeover",
    "week.fri.genres": "Open Format · Chart Hits · UK Garage · Commercial House",
    "week.fri.sub": "The weekend starts here.",
    "week.sat.title": "Saturdays In Soho",
    "week.sat.genres": "VIP Experiences · Bottle Service · DJs · All Genres",
    "week.sat.sub": "Where bottles pop and memories are made.",
    "week.sun.title": "Sunday Service",
    "week.sun.genres": "UK Garage · R&B · Afrobeats · Industry Night",
    "week.sun.sub": "One last dance before Monday.",

    "find.kicker": "How to find us",
    "find.title.1": "Find",
    "find.title.2": "the door",
    "find.sub": "C.C. Veronicas — the strip's pink-lit corner. Look for the neon.",
    "find.addressLabel": "Address",
    "find.country": "Spain",
    "find.directions": "Open in Google Maps",
    "find.entranceLabel": "The entrance",
    "find.entranceText": "Soho69 is in the Veronicas strip — the entrance is between the palm trees, look for the neon SH wreath.",
    "find.photoPh": "Entrance",

    // Stories
    "stories.overline": "Inside the club",
    "stories.title.1": "Soho69",
    "stories.title.2": "stories",
    "stories.sub": "Tap through real moments from last night.",

    // Line-up
    "lineup.overline": "Line-up",
    "lineup.title.1": "This",
    "lineup.title.2": "week",
    "lineup.sub": "Every night, a reason to go out.",
    "lineup.all": "All events",
    "lineup.empty": "Line-up to be announced",
    "lineup.featured": "Featured",

    // Boss's pick
    "boss.badge": "The boss's pick this week",

    // Glow drops
    "glow.overline": "Every night",
    "glow.title.1": "Glow",
    "glow.title.2": "drops",
    "glow.sub": "Five nights. Five vibes. Free perks at the door for whoever turns up first.",
    "glow.big": "Big one",
    "glow.wed.day": "Wed",
    "glow.wed.title": "Ladies Free",
    "glow.wed.perk": "Free entry for ladies until 00:00",
    "glow.wed.sub": "Free drink on arrival with code SOHOLAD",
    "glow.thu.day": "Thu",
    "glow.thu.title": "Throwback",
    "glow.thu.perk": "2000s & 2010s hits all night",
    "glow.thu.sub": "Sing-along anthems with DJ Marco V",
    "glow.fri.day": "Fri",
    "glow.fri.title": "House Party",
    "glow.fri.perk": "Resident DJs · house & techno",
    "glow.fri.sub": "Mon – Sun · 11:00 till 04:00",
    "glow.sat.day": "Sat",
    "glow.sat.title": "Neon Saturdays",
    "glow.sat.perk": "The signature night",
    "glow.sat.sub": "DJ Sirena B2B · mainstage takeover",
    "glow.sun.day": "Sun",
    "glow.sun.title": "Sundown",
    "glow.sun.perk": "Latin · reggaeton · afro-house",
    "glow.sun.sub": "Terrace closer until sunrise",

    // VIP callout
    "vip.overline": "VIP bottle service",
    "vip.title.1": "Reserve your",
    "vip.title.2": "table",
    "vip.sub": "Three signature packages. From Smirnoff to the legendary Grey Goose by the DJ booth — choose your night, we'll handle the rest.",
    "vip.see": "See packages",
    "vip.reserve": "Reserve",

    // Info strip
    "info.open.title": "Open Mon – Sun",
    "info.open.body": "Doors at 11:00. Last entry 03:00.",
    "info.sparkler.title": "VIP Sparklers",
    "info.sparkler.body": "Every bottle arrives with a show.",
    "info.queue.title": "Skip-the-queue",
    "info.queue.body": "Bookings walk straight in.",

    // Footer
    "foot.about": "Tenerife's neon-pink nightclub. After-dark hits, bottle service and the island's loudest dancefloor.",
    "foot.visit": "Visit",
    "foot.hours": "Mon – Sun · 11:00 AM – 04:00 AM",
    "foot.contact": "Contact",
    "foot.staff": "Staff",
    "foot.staffLogin": "Staff & Management Login →",
    "foot.rights": "All nights reserved",

    // Tables page
    "tables.overline": "VIP bottle service",
    "tables.title.1": "Pick your",
    "tables.title.2": "table",
    "tables.sub": "Three signature packages. Reserve a table and walk straight past the queue. 18+ only · ID at the door.",
    "tables.mostWanted": "Most Wanted",
    "tables.perTable": "per table",
    "tables.reserve": "Reserve",
    "tables.step.1": "Pick your table & date.",
    "tables.step.2": "We confirm by email within 1 hour.",
    "tables.step.3": "Skip the queue. Your bottle is iced and waiting.",

    // Book page
    "book.overline": "VIP bottle service",
    "book.title.1": "Reserve your",
    "book.title.2": "table",
    "book.sub": "Three signature packages, choose your night, we'll handle the rest.",
    "book.seePackages": "See packages",
    "book.pill.1.t": "1 bottle = 6 people",
    "book.pill.1.s": "Each bottle covers up to 6 guests — let us know your party size at checkout.",
    "book.pill.2.t": "Booking holds 20 min",
    "book.pill.2.s": "From your stated arrival time",
    "book.pill.3.t": "Over-18s only",
    "book.pill.3.s": "ID / passport at the door",
    "book.toggle.table": "VIP Packs",
    "book.toggle.ticket": "Entry Ticket",
    "book.toggle.barorder": "VIP Menu",
    "book.barorder.title": "VIP Pre-Order",
    "book.barorder.menuTitle": "Pick your bottles",
    "book.barorder.menuTitleWord1": "Pick your",
    "book.barorder.menuTitleWord2": "bottles",
    "book.barorder.menuSub": "Build your own package — pick the bottles, we'll have them ready when you arrive. No table required.",
    "book.barorder.alsoTable": "Are you booking a table?",
    "book.barorder.alsoTableHint": "Tick this if you also want a VIP table — we'll add the table details below.",
    "book.barorder.emptyError": "Add at least one bottle to your pre-order before submitting.",
    "book.field.package": "Table package *",
    "book.field.date.optional": "Date (optional)",
    "book.details.title": "Your details",
    "book.details.sub": "Just your contact details. No sign-ups — your confirmation arrives by email instantly.",
    "book.field.name": "Full name *",
    "book.field.email": "Email *",
    "book.field.whatsapp": "WhatsApp *",
    "book.field.date": "Date *",
    "book.field.arrival": "Arrival *",
    "book.field.party": "Number of people in reservation *",
    "book.field.party.hint": "1 bottle = up to 6 people. Add 1 bottle per 6 guests.",
    "book.placeholder.party": "e.g. 6",
    "book.field.tickets": "How many tickets? *",
    "book.field.event": "Event (optional)",
    "book.field.notes": "Notes (optional)",
    "book.placeholder.name": "Your name",
    "book.placeholder.notes": "Birthday? Special requests?",
    "book.placeholder.event": "e.g. Neon Saturdays — or leave blank for general entry",
    "book.confirm": "We send your booking confirmation by email. WhatsApp is only used for last-minute door queries.",
    "book.bottle.title.1": "Pick your",
    "book.bottle.title.2": "package",
    "book.bottle.sub": "Each table comes with the signature bottle of the package.",
    "book.bottles.title": "VIP Bottle Menu",
    "book.bottles.sub": "Add extra bottles to your table — listed here for the door staff and added to your booking.",
    "book.summary": "Summary",
    "book.summary.date": "Date",
    "book.summary.arrival": "Arrival",
    "book.summary.party": "Party size",
    "book.summary.capacity": "Capacity",
    "book.summary.event": "Event",
    "book.summary.tickets": "Tickets",
    "book.summary.total": "Total",
    "book.submit": "Confirm booking",
    "book.submitting": "Confirming…",
    "book.disclaimer": "30% Deposit online · 70% Balance due at the club · 18+ only · ID at the door",
    "book.success.title.1": "Locked",
    "book.success.title.2": "in",
    "book.success.sub": "Confirmation just landed in your inbox",
    "book.success.within": "within 1 hour.",
    "book.success.ref": "Reference",
    "book.success.qrLabel": "Show this QR at the door",
    "book.success.qrHint": "Check your inbox — we just emailed the QR. Booking holds 20 min from your arrival time.",
    "book.success.another": "Book another night",
    "book.people": "people",
    "book.tier.standard": "Standard",
    "book.tier.premium": "Premium",
    "book.tier.exclusive": "Exclusive",
    "book.pick": "Pick a table",

    // Bottle menu
    "bottles.kicker": "Build your night",
    "bottles.title.1": "VIP Bottle",
    "bottles.title.2": "menu",
    "bottles.perk": "Every package · free fizz & unlimited mixers",
    "bottles.note": "All prices in euros. Tap + to add bottles to your booking.",
    "bottles.onRequest": "On request",
    "bottles.cat.vodka": "Vodka",
    "bottles.cat.gin": "Gin",
    "bottles.cat.brandy": "Brandy",
    "bottles.cat.whiskey": "Whiskey",
    "bottles.cat.rum": "Rum",
    "bottles.cat.champagne": "Champagne",
    "bottles.selected": "selected",
    "bottles.from": "Bottles",
    "bottles.book": "Add to booking",
    "bottles.disclaimer": "Bottle service is reserved for table guests only. Subject to availability — 18+ only.",

    // WhatsApp
    "wa.hover": "WhatsApp the boss",

    // Events page
    "events.overline": "What's on",
    "events.title.1": "Events",
    "events.title.2": "Line-up",
    "events.amp": "&",
    "events.sub": "Every night a reason to go out. Tap into the line-up, book your spot, and let us do the rest.",
    "events.empty": "Line-up to be announced soon.",
    "events.featured": "Featured",
    "events.getTickets": "Get Tickets",
    "events.bookTable": "Book Table",
    "events.specialKicker": "Special events",
    "events.specialTitle": "One-off nights",

    // Gallery page
    "gallery.overline": "In the dark",
    "gallery.title.1": "Gallery",
    "gallery.title.2": "Soho69",
    "gallery.sub": "Frames from the dancefloor, the booth and everywhere in between. This is what your night looks like.",

    // Tickets page
    "tickets.overline": "Entry tickets",
    "tickets.title.1": "Pick Your",
    "tickets.title.2": "Card",
    "tickets.sub": "Skip the door fee and reserve your entry. We'll email your confirmation instantly.",
    "tickets.general.title": "General Entry",
    "tickets.general.sub": "Standard entry for any open night. 18+ only · ID required at the door.",
    "tickets.general.cta": "Reserve Entry",
    "tickets.event.cta": "Get Tickets",
    "tickets.event.sub": "Reserve entry for this special night.",

    // Contact page
    "contact.overline": "Get in touch",
    "contact.title.1": "Find",
    "contact.title.2": "us",
    "contact.sub": "Lost in Playa de las Américas? Look for the neon pink sign — you can't miss it.",
    "contact.card.address": "Address",
    "contact.card.hours": "Open hours",
    "contact.card.phone": "Phone",
    "contact.card.whatsapp": "WhatsApp bookings",
    "contact.card.email": "Email",
    "contact.card.instagram": "Instagram",
    "contact.card.tiktok": "TikTok",
    "contact.address.lines": "C.C. Verónicas 3\nPlaya de las Américas · Tenerife",
    "contact.hours.lines": "Monday – Sunday\n11:00 AM – 04:00 AM",
    "contact.rules.title": "House rules",
    "contact.rules.1": "Over 18s only. Bring valid ID / passport.",
    "contact.rules.2": "Respect our team. Abuse towards staff or security won't be accepted.",
    "contact.rules.3": "Look after your belongings. Soho69 cannot accept responsibility for lost or stolen items.",
    "contact.rules.4": "Right of admission reserved. Management reserves the right to refuse entry or service.",
    "contact.rules.5": "📱 If you film your night… tag @soho69tfs.",
    "contact.rules.6": "🍾 Buy the bottle. Regret is temporary. Memories are forever.",

    // Login page
    "login.kicker": "Sign in",
    "login.title": "Login",
    "login.email": "Email",
    "login.password": "Password",
    "login.submit": "Enter",
    "login.submitting": "Authenticating…",
    "login.back": "← Back to site",
    "login.welcome": "Welcome back",
    "login.side.title.1": "Staff",
    "login.side.title.2": "command",
    "login.side.sub": "The boss runs the club. Staff check guests in at the door. Welcome to the back-of-house.",

    // Soho 6+6 Top-Shelf Loyalty Card
    "loyalty.home.kicker": "Top Shelf Loyalty",
    "loyalty.home.tagline": "Pre-paid online · 6 Top Shelf drinks + 6 shots, ready when you walk in.",
    "loyalty.home.bullet1": "6 Top Shelf drinks (Belvedere · Grey Goose · Hennessy & more)",
    "loyalty.home.bullet2": "6 House Shots — pick at the bar",
    "loyalty.home.bullet3": "QR sent by email — show it at the door",
    "loyalty.home.cta": "Buy now · €30",
    "loyalty.home.priceLabel": "Pre-paid online",
    "loyalty.home.disclaimer": "Non-transferable · No cash value · One mark per item",
    "loyalty.kicker": "Soho69 · Top Shelf Drinks Ticket",
    "loyalty.tagline": "Pre-paid €30. Includes 6 Top-Shelf Drinks + 6 Shots — served throughout your night.",
    "loyalty.includes": "6 drinks + 6 shots",
    "loyalty.field.name": "Full name *",
    "loyalty.field.phone": "Phone *",
    "loyalty.field.email": "Email *",
    "loyalty.placeholder.name": "Your name",
    "loyalty.submit": "· Get my card",
    "loyalty.submitting": "Processing…",
    "loyalty.terms": "By buying, you accept the door age check & house rules.",
    "loyalty.buy.success.toast": "Card created — show your QR at the door",
    "loyalty.buy.success.title": "Card created!",
    "loyalty.buy.success.sub": "We've emailed your QR to {email}. The manager scans it at the door to activate your 12 slots.",
    "loyalty.buy.success.show": "Show this QR at the door",
    "loyalty.buy.success.email": "Screenshot this QR to save it — we'll also send the full pass to your email.",
    "loyalty.buy.success.openCard": "Open my live card",
    "loyalty.buy.success.home": "Back home",
    "loyalty.buy.success.ref": "Ref",
    "card.notfound": "Card not found",
    "card.prepaid": "Pre-paid €30",
    "card.pending.title": "Not activated yet",
    "card.pending.sub": "See the manager at the door — they'll scan your QR to unlock the card.",
    "card.counter.drinks": "Drinks used",
    "card.counter.shots": "Shots used",
    "card.footer.line1": "One mark per item redeemed · Non transferable · No cash value",
    "card.footer.line2": "Thank you! — Soho69 Tenerife",
    "card.punch.ok": "Slot redeemed",
    "card.pin.title": "Bar Unlock",
    "card.pin.sub.drink": "Slot",
    "card.pin.sub.shot": "Slot",
    "card.pin.body": "Please hand the phone to bar staff to continue.",
    "card.pin.submit": "Unlock",
    "card.pin.submitting": "Working…",
  },
  es: {
    "nav.home": "Inicio",
    "nav.events": "Eventos",
    "nav.gallery": "Galería",
    "nav.vip": "Mesas VIP",
    "nav.tickets": "Entradas de Bebidas",
    "nav.contact": "Contacto",
    "nav.reserve": "Reservar",
    "nav.reserveTable": "Reservar Mesa",

    "hero.overline": "Playa de las Américas · Tenerife",
    "hero.tagline": "Donde estallan las botellas, suena más fuerte la música y se viven recuerdos inolvidables.",
    "hero.subtag": "Reserva tu mesa y vive la experiencia SOHO69.",
    "hero.cta.reserve": "Reservar Mesa",
    "hero.cta.inside": "Dentro del club",
    "door.openTonight": "Abierto esta noche · puertas en marcha",
    "door.openIn": "Abrimos en",
    "door.closed": "Cerrado · volvemos",
    "door.openNow": "Abierto ahora · ¡ven a vernos!",
    "door.closedBack": "Cerrado · volvemos a las 11:00",

    "ticker.drinks": "Bebidas Premium",
    "ticker.sound": "El mejor sonido",
    "ticker.vip": "Experiencia VIP",
    "ticker.shisha": "Shisha Premium",

    "packages.kicker": "Paquetes de Bebida",
    "packages.title.1": "Elige tu",
    "packages.title.2": "paquete",
    "packages.sub": "Todos los paquetes incluyen cava gratis a la llegada y refrescos ilimitados.",
    "packages.featured": "Más Popular",
    "packages.reserve": "Reservar",
    "packages.build": "Crea tu propio paquete",
    "packages.buildHint": "Mira la carta de botellas VIP completa",

    "week.kicker": "Lo que viene",
    "week.title.1": "Cartel Semanal",
    "week.title.2": "Soho69",
    "week.mon.day": "Lunes",
    "week.tue.day": "Martes",
    "week.wed.day": "Miércoles",
    "week.thu.day": "Jueves",
    "week.fri.day": "Viernes",
    "week.sat.day": "Sábado",
    "week.sun.day": "Domingo",
    "week.mon.title": "Pink Mondays",
    "week.mon.genres": "Noche de Chicas · Cócteles · R&B · House · Ofertas VIP",
    "week.mon.sub": "Empieza la semana en rosa.",
    "week.tue.title": "Tequila Tuesdays",
    "week.tue.genres": "Cócteles 2x1 · Hip-Hop · Dance · Éxitos comerciales",
    "week.tue.sub": "Chupitos, shishas y noches largas.",
    "week.wed.title": "Ballers Club",
    "week.wed.genres": "Mesas VIP · Shows de Botellas · Hip-Hop · Afrobeats",
    "week.wed.sub": "Big spenders, máxima vibra.",
    "week.thu.title": "Sunset Sessions",
    "week.thu.genres": "House · Clásicos Ibiza · Happy Hour · Terraza",
    "week.thu.sub": "La hora dorada se vuelve after.",
    "week.fri.title": "Friday Takeover",
    "week.fri.genres": "Open Format · Éxitos · UK Garage · Commercial House",
    "week.fri.sub": "Aquí empieza el finde.",
    "week.sat.title": "Saturdays In Soho",
    "week.sat.genres": "Experiencias VIP · Servicio de Botellas · DJs · Todos los géneros",
    "week.sat.sub": "Donde explotan las botellas y nacen los recuerdos.",
    "week.sun.title": "Sunday Service",
    "week.sun.genres": "UK Garage · R&B · Afrobeats · Industry Night",
    "week.sun.sub": "Un último baile antes del lunes.",

    "find.kicker": "Cómo encontrarnos",
    "find.title.1": "Encuentra",
    "find.title.2": "la puerta",
    "find.sub": "C.C. Veronicas — la esquina rosa neón del paseo. Busca el cartel.",
    "find.addressLabel": "Dirección",
    "find.country": "España",
    "find.directions": "Abrir en Google Maps",
    "find.entranceLabel": "La entrada",
    "find.entranceText": "Soho69 está en la zona de Veronicas — la entrada está entre las palmeras, busca el neón con la corona SH.",
    "find.photoPh": "Entrada",

    "stories.overline": "Dentro del club",
    "stories.title.1": "Historias",
    "stories.title.2": "Soho69",
    "stories.sub": "Toca para ver momentos reales de anoche.",

    "lineup.overline": "Cartel",
    "lineup.title.1": "Esta",
    "lineup.title.2": "semana",
    "lineup.sub": "Cada noche, un motivo para salir.",
    "lineup.all": "Ver todos",
    "lineup.empty": "Cartel próximamente",
    "lineup.featured": "Destacado",

    "boss.badge": "Elección del jefe esta semana",

    "glow.overline": "Cada noche",
    "glow.title.1": "Glow",
    "glow.title.2": "drops",
    "glow.sub": "Cinco noches. Cinco ambientes. Regalos en la puerta para los primeros que lleguen.",
    "glow.big": "La grande",
    "glow.wed.day": "Mié",
    "glow.wed.title": "Ellas Gratis",
    "glow.wed.perk": "Entrada gratis para ellas hasta las 00:00",
    "glow.wed.sub": "Copa gratis al llegar con el código SOHOLAD",
    "glow.thu.day": "Jue",
    "glow.thu.title": "Throwback",
    "glow.thu.perk": "Éxitos de los 2000 y 2010 toda la noche",
    "glow.thu.sub": "Himnos para cantar con DJ Marco V",
    "glow.fri.day": "Vie",
    "glow.fri.title": "Fiesta House",
    "glow.fri.perk": "DJs residentes · house & techno",
    "glow.fri.sub": "Lun – Dom · 11:00 hasta 04:00",
    "glow.sat.day": "Sáb",
    "glow.sat.title": "Sábados Neón",
    "glow.sat.perk": "La noche estrella",
    "glow.sat.sub": "DJ Sirena B2B · toma del escenario",
    "glow.sun.day": "Dom",
    "glow.sun.title": "Atardecer",
    "glow.sun.perk": "Latin · reggaetón · afro-house",
    "glow.sun.sub": "Cierre en terraza hasta el amanecer",

    "vip.overline": "Servicio de botella VIP",
    "vip.title.1": "Reserva tu",
    "vip.title.2": "mesa",
    "vip.sub": "Tres paquetes exclusivos. Desde Smirnoff hasta el legendario Grey Goose junto a la cabina del DJ — elige tu noche, nosotros hacemos el resto.",
    "vip.see": "Ver paquetes",
    "vip.reserve": "Reservar",

    "info.open.title": "Abierto Lun – Dom",
    "info.open.body": "Lun – Dom · 11am hasta 4am.",
    "info.sparkler.title": "Bengalas VIP",
    "info.sparkler.body": "Cada botella llega con su espectáculo.",
    "info.queue.title": "Sin colas",
    "info.queue.body": "Las reservas entran directas.",

    "foot.about": "El club neón rosa de Tenerife. Hits after-dark, servicio de botellas y la pista más caliente de la isla.",
    "foot.visit": "Visítanos",
    "foot.hours": "Lun – Dom · 11am – 4am",
    "foot.contact": "Contacto",
    "foot.staff": "Equipo",
    "foot.staffLogin": "Acceso Equipo y Gerencia →",
    "foot.rights": "Todos los derechos reservados",

    "tables.overline": "Servicio de botella VIP",
    "tables.title.1": "Elige tu",
    "tables.title.2": "mesa",
    "tables.sub": "Tres paquetes exclusivos. Reserva tu mesa y entra directo sin colas. Solo +18 · DNI en la puerta.",
    "tables.mostWanted": "El más popular",
    "tables.perTable": "por mesa",
    "tables.reserve": "Reservar",
    "tables.step.1": "Elige tu mesa y fecha.",
    "tables.step.2": "Te confirmamos por WhatsApp en menos de 1 hora.",
    "tables.step.3": "Sin colas. Tu botella está fría y esperándote.",

    "book.overline": "Servicio de botella VIP",
    "book.title.1": "Reserva tu",
    "book.title.2": "mesa",
    "book.sub": "Tres paquetes exclusivos, elige tu noche, nosotros nos encargamos del resto.",
    "book.seePackages": "Ver paquetes",
    "book.pill.1.t": "1 botella = 6 personas",
    "book.pill.1.s": "Cada botella cubre hasta 6 invitados — indícanos cuántos sois al hacer la reserva.",
    "book.pill.2.t": "Reserva guardada 20 min",
    "book.pill.2.s": "Desde la hora de llegada",
    "book.pill.3.t": "Solo +18",
    "book.pill.3.s": "DNI o pasaporte en la puerta",
    "book.toggle.table": "Packs VIP",
    "book.toggle.ticket": "Entrada",
    "book.toggle.barorder": "Carta VIP",
    "book.barorder.title": "Pre-Pedido VIP",
    "book.barorder.menuTitle": "Elige tus botellas",
    "book.barorder.menuTitleWord1": "Elige tus",
    "book.barorder.menuTitleWord2": "botellas",
    "book.barorder.menuSub": "Crea tu propio pack — elige las botellas y las tendremos listas a tu llegada. Sin mesa requerida.",
    "book.barorder.alsoTable": "¿Quieres reservar también una mesa?",
    "book.barorder.alsoTableHint": "Marca esto si además quieres mesa VIP — añadiremos los detalles abajo.",
    "book.barorder.emptyError": "Añade al menos una botella antes de enviar tu pedido.",
    "book.field.package": "Pack de mesa *",
    "book.field.date.optional": "Fecha (opcional)",
    "book.details.title": "Tus datos",
    "book.details.sub": "Solo tus datos de contacto. Sin registros — la confirmación llega al instante por email.",
    "book.field.name": "Nombre completo *",
    "book.field.email": "Email *",
    "book.field.whatsapp": "WhatsApp *",
    "book.field.date": "Fecha *",
    "book.field.arrival": "Llegada *",
    "book.field.party": "Personas en la reserva *",
    "book.field.party.hint": "1 botella = hasta 6 personas. Añade 1 botella por cada 6 invitados.",
    "book.placeholder.party": "ej. 6",
    "book.field.tickets": "¿Cuántas entradas? *",
    "book.field.event": "Evento (opcional)",
    "book.field.notes": "Notas (opcional)",
    "book.placeholder.name": "Tu nombre",
    "book.placeholder.notes": "¿Cumpleaños? ¿Petición especial?",
    "book.placeholder.event": "p.ej. Sábados Neón — o déjalo en blanco",
    "book.confirm": "Te enviamos la confirmación por email. WhatsApp solo se usa para consultas de última hora en la puerta.",
    "book.bottle.title.1": "Elige tu",
    "book.bottle.title.2": "paquete",
    "book.bottle.sub": "Cada mesa incluye la botella del paquete.",
    "book.bottles.title": "Carta de Botellas VIP",
    "book.bottles.sub": "Añade botellas extra a tu mesa — quedan registradas en tu reserva.",
    "book.summary": "Resumen",
    "book.summary.date": "Fecha",
    "book.summary.arrival": "Llegada",
    "book.summary.party": "Personas",
    "book.summary.capacity": "Capacidad",
    "book.summary.event": "Evento",
    "book.summary.tickets": "Entradas",
    "book.summary.total": "Total",
    "book.submit": "Confirmar reserva",
    "book.submitting": "Confirmando…",
    "book.disclaimer": "Depósito 30% online · Resto 70% en el club · solo +18 · DNI en la puerta",
    "book.success.title.1": "Reservado",
    "book.success.title.2": "✓",
    "book.success.sub": "Confirmación enviada a tu email",
    "book.success.within": "en 1 hora.",
    "book.success.ref": "Referencia",
    "book.success.qrLabel": "Enseña este QR en la puerta",
    "book.success.qrHint": "Revisa tu bandeja de entrada — acabamos de enviarte el QR. La reserva se guarda 20 min desde tu hora de llegada.",
    "book.success.another": "Reservar otra noche",
    "book.people": "personas",
    "book.tier.standard": "Standard",
    "book.tier.premium": "Premium",
    "book.tier.exclusive": "Exclusive",
    "book.pick": "Elige una mesa",

    "bottles.kicker": "Crea tu noche",
    "bottles.perk": "Cada paquete · cava gratis y refrescos ilimitados",
    "bottles.note": "Precios en euros. Toca + para añadir botellas a tu reserva.",
    "bottles.onRequest": "A consultar",
    "bottles.cat.vodka": "Vodka",
    "bottles.cat.gin": "Ginebra",
    "bottles.cat.brandy": "Brandy",
    "bottles.cat.whiskey": "Whisky",
    "bottles.cat.rum": "Ron",
    "bottles.cat.champagne": "Champán",
    "bottles.selected": "seleccionadas",
    "bottles.from": "Botellas",
    "bottles.book": "Añadir a reserva",
    "bottles.disclaimer": "El servicio de botella es solo para mesas. Sujeto a disponibilidad — solo +18.",

    "wa.hover": "Escribe al jefe",

    "events.overline": "Lo que viene",
    "events.title.1": "Eventos",
    "events.title.2": "Cartel",
    "events.amp": "y",
    "events.sub": "Cada noche, un motivo para salir. Mira el cartel, reserva tu sitio y nosotros nos encargamos del resto.",
    "events.empty": "Cartel próximamente.",
    "events.featured": "Destacado",
    "events.getTickets": "Conseguir entradas",
    "events.bookTable": "Reservar mesa",
    "events.specialKicker": "Eventos especiales",
    "events.specialTitle": "Noches únicas",

    "gallery.overline": "En la noche",
    "gallery.title.1": "Galería",
    "gallery.title.2": "Soho69",
    "gallery.sub": "Imágenes de la pista, la cabina y todo lo que pasa entre medias. Así se vive una noche en Soho69.",

    "tickets.overline": "Entradas",
    "tickets.title.1": "Elige tu",
    "tickets.title.2": "tarjeta",
    "tickets.sub": "Sáltate la cola y reserva tu entrada. Te enviamos la confirmación por email al instante.",
    "tickets.general.title": "Entrada General",
    "tickets.general.sub": "Acceso estándar para cualquier noche. Solo +18 · DNI obligatorio en la puerta.",
    "tickets.general.cta": "Reservar entrada",
    "tickets.event.cta": "Conseguir entradas",
    "tickets.event.sub": "Reserva tu entrada para esta noche especial.",

    "contact.overline": "Contacto",
    "contact.title.1": "Encuén-",
    "contact.title.2": "tranos",
    "contact.sub": "¿Perdido en Playa de las Américas? Busca el cartel rosa neón — no tiene pérdida.",
    "contact.card.address": "Dirección",
    "contact.card.hours": "Horario",
    "contact.card.phone": "Teléfono",
    "contact.card.whatsapp": "Reservas WhatsApp",
    "contact.card.email": "Email",
    "contact.card.instagram": "Instagram",
    "contact.card.tiktok": "TikTok",
    "contact.address.lines": "C.C. Verónicas 3\nPlaya de las Américas · Tenerife",
    "contact.hours.lines": "Lunes – Domingo\n11:00 AM – 04:00 AM",
    "contact.rules.title": "Normas de la casa",
    "contact.rules.1": "Solo mayores de 18. DNI / pasaporte obligatorio.",
    "contact.rules.2": "Respeta a nuestro equipo. No se tolera el abuso hacia el personal ni la seguridad.",
    "contact.rules.3": "Cuida tus pertenencias. Soho69 no se hace responsable de objetos perdidos o robados.",
    "contact.rules.4": "Derecho de admisión reservado. La dirección se reserva el derecho de denegar la entrada o el servicio.",
    "contact.rules.5": "📱 Si grabas tu noche… etiquétanos @soho69tfs.",
    "contact.rules.6": "🍾 Compra la botella. El arrepentimiento es temporal. Los recuerdos son para siempre.",

    "login.kicker": "Iniciar sesión",
    "login.title": "Acceso",
    "login.email": "Email",
    "login.password": "Contraseña",
    "login.submit": "Entrar",
    "login.submitting": "Autenticando…",
    "login.back": "← Volver al sitio",
    "login.welcome": "Bienvenido de nuevo",
    "login.side.title.1": "Panel del",
    "login.side.title.2": "equipo",
    "login.side.sub": "El jefe lleva el club. El equipo registra a los invitados en la puerta. Bienvenido a la trastienda.",

    "media.noVideo": "Sin vídeo todavía",
    "media.uploadHint": "Súbelo desde la consola del jefe",
    "media.bossHint": "El jefe puede subir un clip de introducción desde la consola",

    // Soho 6+6 Loyalty Card (ES)
    "loyalty.home.kicker": "Tarjeta Top Shelf",
    "loyalty.home.tagline": "Prepago online · 6 copas Top Shelf + 6 chupitos, listos al entrar.",
    "loyalty.home.bullet1": "6 copas Top Shelf (Belvedere · Grey Goose · Hennessy y más)",
    "loyalty.home.bullet2": "6 chupitos de la casa — elígelos en la barra",
    "loyalty.home.bullet3": "QR por email — enséñalo en la puerta",
    "loyalty.home.cta": "Compra ya · €30",
    "loyalty.home.priceLabel": "Prepago online",
    "loyalty.home.disclaimer": "Intransferible · Sin valor en efectivo · Una marca por consumición",
    "loyalty.kicker": "Soho69 · Entrada Top Shelf",
    "loyalty.tagline": "€30 prepago. Incluye 6 copas Top-Shelf + 6 chupitos — servidos durante tu noche.",
    "loyalty.includes": "6 copas + 6 chupitos",
    "loyalty.field.name": "Nombre completo *",
    "loyalty.field.phone": "Teléfono *",
    "loyalty.field.email": "Email *",
    "loyalty.placeholder.name": "Tu nombre",
    "loyalty.submit": "· Conseguir mi tarjeta",
    "loyalty.submitting": "Procesando…",
    "loyalty.terms": "Al comprar aceptas el control de edad y las normas del club.",
    "loyalty.buy.success.toast": "Tarjeta creada — enseña tu QR en la puerta",
    "loyalty.buy.success.title": "¡Tarjeta creada!",
    "loyalty.buy.success.sub": "Te hemos enviado tu QR a {email}. El encargado lo escanea en la puerta para activar tus 12 huecos.",
    "loyalty.buy.success.show": "Enseña este QR en la puerta",
    "loyalty.buy.success.email": "Envío por email próximamente — por ahora haz captura del QR.",
    "loyalty.buy.success.openCard": "Abrir mi tarjeta",
    "loyalty.buy.success.home": "Volver al inicio",
    "loyalty.buy.success.ref": "Ref",
    "card.notfound": "Tarjeta no encontrada",
    "card.prepaid": "€30 prepago",
    "card.pending.title": "Aún no activada",
    "card.pending.sub": "Habla con el encargado — escaneará tu QR para desbloquear la tarjeta.",
    "card.counter.drinks": "Copas usadas",
    "card.counter.shots": "Chupitos usados",
    "card.footer.line1": "Una marca por consumición · Intransferible · Sin valor en efectivo",
    "card.footer.line2": "¡Gracias! — Soho69 Tenerife",
    "card.punch.ok": "Hueco marcado",
    "card.pin.title": "Desbloqueo",
    "card.pin.sub.drink": "Hueco",
    "card.pin.sub.shot": "Hueco",
    "card.pin.body": "Entrega el móvil al personal del bar para continuar.",
    "card.pin.submit": "Desbloquear",
    "card.pin.submitting": "Procesando…",
  },
};

const LangCtx = createContext(null);
const STORAGE_KEY = "soho69_lang";

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "en";
    const saved = window.localStorage.getItem(STORAGE_KEY);
    return saved === "es" || saved === "en" ? saved : "en";
  });

  useEffect(() => {
    if (typeof window !== "undefined") window.localStorage.setItem(STORAGE_KEY, lang);
    if (typeof document !== "undefined") document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((l) => setLangState(l === "es" ? "es" : "en"), []);
  const t = useCallback(
    (key) => (dict[lang] && dict[lang][key]) ?? dict.en[key] ?? key,
    [lang]
  );

  return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
}

export function useLang() {
  const ctx = useContext(LangCtx);
  if (!ctx) return { lang: "en", setLang: () => {}, t: (k) => dict.en[k] ?? k };
  return ctx;
}
